const STOP_WORDS = new Set([
  'a',
  'an',
  'the',
  'for',
  'of',
  'in',
  'on',
  'to',
  'and',
  'or',
  'but',
  'is',
  'vs',
  'with',
])

const MAX_SLUG_LENGTH = 75

export function generateSeoSlug(
  input: string,
  maxLength = MAX_SLUG_LENGTH
): string {
  const normalized = input
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, ' ')
    .split(/\s+/)
    .filter(Boolean)
    .filter((word, index) => index === 0 || !STOP_WORDS.has(word))
    .join('-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')

  if (normalized.length <= maxLength) return normalized

  const trimmed = normalized.slice(0, maxLength).replace(/-+[^-]*$/, '')
  return trimmed.replace(/^-|-$/g, '')
}

export function validateSeoSlug(slug: string): {
  valid: boolean
  errors: string[]
} {
  const errors: string[] = []

  if (!slug) errors.push('Slug is required.')
  if (slug !== slug.toLowerCase()) errors.push('Slug must be lowercase.')
  if (!/^[a-z0-9-]+$/.test(slug)) {
    errors.push(
      'Slug may contain only lowercase letters, numbers, and hyphens.'
    )
  }
  if (slug.startsWith('-') || slug.endsWith('-')) {
    errors.push('Slug cannot start or end with a hyphen.')
  }
  if (slug.includes('--'))
    errors.push('Slug cannot contain consecutive hyphens.')
  if (slug.length > MAX_SLUG_LENGTH) {
    errors.push(`Slug must be ${MAX_SLUG_LENGTH} characters or fewer.`)
  }

  return {
    valid: errors.length === 0,
    errors,
  }
}
